export default {
  haveRead: '本人已閱讀，知悉及明白「內部轉賬相關費用明細」',
  fundTransferTipsTitle: '內部轉賬相關費用明細',
  fundTransferTips: {
    exchangePriceDifferenceCompany: {
      title: '兌換差價 (本公司收取)',
      tips: '如內部轉賬間之交易賬戶結算貨幣是不同,本公司會以本公司適用的銀行匯率兌換成存款賬戶貨幣後進行存款, 過程中有可能產生兌換差價。'
    }
  },
  placeholderAmount: '請輸入金額',
  maxText: '最大可轉'
}
